module.exports = "/_next/static/images/nofeealt-bc915eccdee7f7efc8f9340236be8ccf.svg";